const localHosts = new Set(['localhost', '127.0.0.1', '::1', '[::1]']);

export function isLocalHost(hostname = window.location.hostname) {
    return localHosts.has(hostname);
}

export function formatTitleForEnvironment(title) {
    const testingPrefix = '[TESTING]';
    const normalizedTitle = (title || '').replace(`${testingPrefix} `, '');

    if (!isLocalHost()) {
        return normalizedTitle;
    }

    return `${testingPrefix} ${normalizedTitle}`;
}
